import { makeStyles } from '@material-ui/core/styles';

export const LinkToRelatedListStyles = makeStyles({
  icon: { paddingRight: '0.5em' },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
  },
});